import React, { useState } from 'react'
import CreateTicketPage from './CreateTicketPage'
import ViewTicketPage from './ViewTicketPage'

export default function SupportPage() {
  const [ticketId, setTicketId] = useState(false)

  return ticketId ? (
    <ViewTicketPage ticketId={ticketId} />
  ) : (
    <CreateTicketPage setTicketId={setTicketId} />
  )
}
